<template>
  <ab-test-wrapper css-class="ab-test-inline-age show-a">
    <template #component_a>
      <MoleculesInlineAge
        :title="title"
        :subtitle="subtitle"
        :disclaimer="disclaimer"
        :vertical="vertical"
        :redirect-url="redirectUrl"
      />
    </template>

    <template #component_b>
      <MoleculesInlineAge
        :title="title"
        :subtitle="subtitle"
        :disclaimer="disclaimer"
        :vertical="vertical"
        :redirect-url="redirectUrl"
        theme="v2"
      />
    </template>
  </ab-test-wrapper>
</template>
<script setup>

defineOptions({
  name: 'OrganismsInlineAgeAbTest'
})

defineProps({
  title: {
    type: String,
    default: 'Paying too much?'
  },
  subtitle: {
    type: String,
    default: '<strong>Australia:</strong> We saved our customers an average of $300* on their annual premium! <strong>Select your age below</strong> and see how much you could save!'
  },
  disclaimer: {
    type: String,
    default: '*Average savings based on 136,746 customers between 1 Jan 2018 - 23 December 2022'
  },
  vertical: {
    type: String,
    default: 'Health Insurance'
  },
  redirectUrl: {
    type: String,
    default: '/health-insurance/quote/form/step1/'
  }
})
</script>
